import request from "../../../core/wrappers/axios-wrapper";
import { ApiURL } from "../../../types/constants/apiUrls/api-urls";
import { RequestType } from "../../../types/enums/request-enums";

 const UpdateCargoFee=(data:any):Promise<any>=>request({
  url:ApiURL.Command.UpdateCargoFee,
  method: RequestType.PUT,
  data
 });
 const AddCargoFee=(data:any):Promise<any>=>request({
  url:ApiURL.Command.AddCargoFee,
  method: RequestType.POST,
  data
 });
 const AddCargoFeeFromExcel=(data:any)=>request({
  url:ApiURL.Command.AddCargoFeeFromExcel,
  method: RequestType.POST,
  data
 });
 const DeleteCargoFee=(data:any):Promise<any>=>request({
  url:ApiURL.Command.DeleteCargoFee,
  method: RequestType.POST,
  data
 });

const CargoFeeManagementCommand = {
  UpdateCargoFee,
  DeleteCargoFee,
  AddCargoFee,
  AddCargoFeeFromExcel
};

export default CargoFeeManagementCommand;
